import { Separator } from "../../../app/components/ui/separator";
import { formatInr } from "../../../lib/currency";

export function PosBillSummary({
  subtotalTaxable,
  discountTotal,
  gstTotal,
  grandTotal,
  showComplianceWarning,
  appliedPromotionLabel,
}: {
  subtotalTaxable: number;
  discountTotal?: number;
  gstTotal: number;
  grandTotal: number;
  showComplianceWarning: boolean;
  appliedPromotionLabel?: string | null;
}) {
  const hasDiscount = typeof discountTotal === "number" && Number.isFinite(discountTotal) && discountTotal > 0;
  return (
    <div className="space-y-2 shrink-0">
      {appliedPromotionLabel ? (
        <div className="text-xs text-muted-foreground">
          Applied offer: <span className="font-medium text-foreground">{appliedPromotionLabel}</span>
        </div>
      ) : null}
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">Subtotal</span>
        <span className="font-medium">{formatInr(subtotalTaxable)}</span>
      </div>
      {hasDiscount ? (
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Discount</span>
          <span className="font-medium text-emerald-700 dark:text-emerald-400">-{formatInr(discountTotal!)}</span>
        </div>
      ) : null}
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">GST</span>
        <span className="font-medium">{formatInr(gstTotal)}</span>
      </div>
      <Separator />
      <div className="flex justify-between">
        <span className="font-semibold">Total</span>
        <span className="font-bold text-xl text-primary">{formatInr(grandTotal)}</span>
      </div>
      {showComplianceWarning ? (
        <p className="text-xs text-amber-700 dark:text-amber-400">
          Includes non-compliant tax adjustments
        </p>
      ) : null}
    </div>
  );
}
